export type Cirugia = {
  cirugia: string;
  descripcion: string;
  costo: string;
};

export const getEmptyCirugias: Cirugia[] = [];
